export default "/STG.78950f66250cbcba0a4bf3013e4f2727.png";